{
    "options": [
        {
            "value": "-1M",
            "label": "Last minute"
        },
        {
            "value": "-30M",
            "label": "Last 30 minutes"
        },
        {
            "value": "-1h",
            "label": "Last hour"
        },
        {
            "value": "-3h",
            "label": "Last 3 hours"
        },
        {
            "value": "-24h",
            "label": "Last 24 hours"
        },
        {
            "value": "-7d",
            "label": "Last 7 days"
        },
        {
            "value": "-14d",
            "label": "Last 14 days"
        },
        {
            "value": "-30d",
            "label": "Last 30 days"
        },
        {
            "value": "-90d",
            "label": "Last 90 days"
        }
    ]
}
